import React from 'react';
import { string, arrayOf } from 'prop-types';
import { Block } from 'components/common';
import Feature from 'components/product/Feature';
import './ProviderFeaturesPanel.scss';

const ProviderFeaturesPanel = ({ heading, pros }) => (
  <div className="provider-features-container">
    <Block>
      <Block.Header title={heading} />
      <div className="features-container-wrapper">
        <div className="features-row-wrapper">
          <div className="features-col-wrapper">
            <div className="features">
              {pros.map(pro => (
                <div key={pro} className="feature-wrapper">
                  <Feature pro={true} htmlString={pro} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Block>
  </div>
);

ProviderFeaturesPanel.propTypes = {
  heading: string,
  pros: arrayOf(string),
};

ProviderFeaturesPanel.defaultProps = {
  heading: null,
  pros: [],
};

export default ProviderFeaturesPanel;
